import { Grid } from "@mui/material";
import InsightsReports from "./InsightsReports";
import styles from './InsightReportSection.module.css';
import InsightReportsLogo from "./InsightReportsLogo";
import Container from '@mui/material/Container';
function ReportsSection() {
  return (
    <div>
      <Container maxWidth="xl">
      <Grid container className={styles.ReportsSection_mainwrap}>
        <Grid item xs={12} md={12} lg={6}  order={{ xs: 2, md: 2, lg: 1 }} className={styles.logosection}>
          <InsightReportsLogo />
        </Grid>

        <Grid item xs={12} md={12} lg={6} order={{ xs: 1, md: 1, lg: 2  }} className={styles.ReportsSection}>
          <InsightsReports />
        </Grid>

      </Grid>
      </Container>
    </div>
  )
}

export default ReportsSection;
